import React, { useState } from 'react';

const BusinessConsultationServices = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Business Consultation.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Business Consultation.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Business Consultation Services
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Expert business consultation services to help you start, grow, and optimize your business. Get strategic guidance on business planning, market entry, operations, and growth strategies from experienced business consultants.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">💡</span> Get Expert Business Guidance
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Our Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">What We Need</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Business Consultation Services
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Professional business consultation provides expert guidance to help entrepreneurs and businesses make informed decisions, overcome challenges, and achieve sustainable growth. Our consultants bring years of industry experience and strategic thinking to your business challenges.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive business consultation services cover business planning, market research, operational optimization, growth strategies, and performance improvement. We provide actionable insights and practical solutions tailored to your specific business needs.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Whether you're starting a new venture, expanding operations, or optimizing existing processes, our business consultants provide the strategic guidance you need to succeed in today's competitive market.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Strategic Business Planning:</strong> Comprehensive business plans, market analysis, and growth roadmaps for sustainable success.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Market Research & Analysis:</strong> In-depth market studies, competitor analysis, and customer insights for informed decision-making.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Operational Optimization:</strong> Process improvement, efficiency enhancement, and cost reduction strategies.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Growth Strategy Development:</strong> Market expansion plans, product diversification, and scaling strategies.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Financial Planning & Modeling:</strong> Revenue projections, financial modeling, and investment planning.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Risk Assessment & Mitigation:</strong> Identify potential risks and develop strategies to minimize business vulnerabilities.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Industry Expertise:</strong> Access to consultants with specific industry knowledge and experience.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Business Consultation." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Business Consultation
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "🔍", title: "Initial Discovery", desc: "Comprehensive understanding of your business, goals, challenges, and current situation." },
              { number: "02", icon: "📋", title: "Data Collection", desc: "Gather business data, financial records, market information, and operational details." },
              { number: "03", icon: "📊", title: "Analysis & Assessment", desc: "Analyze business performance, market position, strengths, weaknesses, and opportunities." },
              { number: "04", icon: "🎯", title: "Strategy Development", desc: "Create customized business strategies and action plans based on analysis findings." },
              { number: "05", icon: "📝", title: "Solution Design", desc: "Design specific solutions, processes, and implementation frameworks for your business." },
              { number: "06", icon: "👥", title: "Implementation Planning", desc: "Develop detailed implementation roadmap with timelines, resources, and responsibilities." },
              { number: "07", icon: "⚙️", title: "Execution Support", desc: "Provide guidance and support during implementation phase to ensure successful execution." },
              { number: "08", icon: "🏆", title: "Review & Optimization", desc: "Monitor results, measure performance, and optimize strategies for continuous improvement." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Information We Need
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential Business Information
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "Business Plan", desc: "Current business plan, vision, mission, and strategic objectives documentation." },
              { icon: "💰", title: "Financial Records", desc: "Financial statements, tax returns, cash flow statements, and revenue projections." },
              { icon: "📊", title: "Performance Data", desc: "Sales data, customer metrics, operational KPIs, and performance reports." },
              { icon: "👥", title: "Organizational Structure", desc: "Team details, organizational chart, and human resources information." },
              { icon: "🛒", title: "Market Information", desc: "Market research, competitor analysis, customer feedback, and industry trends." },
              { icon: "⚙️", title: "Operational Details", desc: "Process documentation, workflow charts, and operational challenges faced." },
              { icon: "🎯", title: "Goals & Objectives", desc: "Specific business goals, growth targets, and success metrics you want to achieve." },
              { icon: "🛡️", title: "Challenges & Issues", desc: "Current business challenges, pain points, and specific problems needing solutions." },
              { icon: "📈", title: "Growth Plans", desc: "Expansion plans, new market entry strategies, and investment requirements." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📄", title: "Comprehensive Business Report", desc: "Detailed business analysis report with findings, insights, and strategic recommendations." },
              { icon: "🎯", title: "Strategic Action Plan", desc: "Customized strategic plan with clear objectives, initiatives, and implementation roadmap." },
              { icon: "📊", title: "Financial Projections", desc: "Detailed financial models, revenue projections, and investment requirement analysis." },
              { icon: "⚙️", title: "Operational Framework", desc: "Process improvement plans, operational guidelines, and efficiency enhancement strategies." },
              { icon: "🎧", title: "Ongoing Consultation", desc: "Implementation support, progress monitoring, strategy adjustments, performance review sessions" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Business Consultation FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "When should a business consider hiring a business consultant?", 
                    answer: "Businesses should consider consultants when starting up, facing growth challenges, entering new markets, experiencing operational inefficiencies, preparing for funding, or when needing expert guidance for strategic decisions." 
                  },
                  { 
                    question: "How long does a typical business consultation engagement last?", 
                    answer: "Engagement duration varies based on project scope - from 2-4 weeks for specific problem-solving to 3-6 months for comprehensive business transformation projects. We offer both short-term and long-term engagement options." 
                  },
                  { 
                    question: "What industries do your business consultants specialize in?", 
                    answer: "Our consultants have expertise across multiple industries including manufacturing, retail, technology, healthcare, education, professional services, and e-commerce. We match consultants with relevant industry experience to your business." 
                  },
                  { 
                    question: "How do you measure the success of business consultation?", 
                    answer: "Success is measured through specific KPIs including revenue growth, cost reduction, operational efficiency improvements, customer satisfaction increases, and achievement of strategic objectives defined at project outset." 
                  },
                  { 
                    question: "Can business consultants help with fundraising and investor pitching?", 
                    answer: "Yes, we help prepare business plans, financial models, investor presentations, and provide coaching for investor meetings. We also assist in identifying suitable funding sources and preparing due diligence materials." 
                  },
                  { 
                    question: "What makes your business consultation services different?", 
                    answer: "Our approach combines strategic thinking with practical implementation support. We provide not just recommendations but also help with execution, and our consultants have real-world business experience rather than just theoretical knowledge." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for Strategic Business Guidance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our experienced business consultants provide the strategic guidance and practical solutions your business needs to grow and succeed.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Business Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default BusinessConsultationServices;